import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { FormatCurrencyForDisplay } from '@unified-checkout/design-system';

import { ItemsListBox } from '@app/dashboard/components/inner_layout/Cards/ItemsListBox';

const CheckoutSummary = ({
  checkout_summary,
}: {
  checkout_summary: {
    img: string;
    title: string;
    sub_title: string;
    quantity: number;
    amount: number;
    currency: string;
  }[];
}) => {
  const { t } = useTranslation();

  const memoizedCheckoutSummary = useMemo(()=> {
    if (!checkout_summary) return [];

    return checkout_summary.map((item: any) => ({
        img: item.img,
        name: item.title,
        category: item.sub_title,
        quantity: item.quantity,
        price: `${item.amount} ${FormatCurrencyForDisplay(item.currency)}`,
      }))
  }, [checkout_summary])

  return (
    <ItemsListBox
      title={t('innerLayout.transactionsPage.singleTransactionsPage.detailsBoxes.checkoutSummary.title')}
      itemsList={memoizedCheckoutSummary}
    />
  );
};

export default CheckoutSummary;
